import { useRouter } from 'next/router';
import React, { ChangeEvent, useCallback } from 'react';

import { Box } from '@mui/material';

import CourseDiscussionBox from './courseDiscussionBox';

import Pagination from '@components/share/navigation/pagination';
import { useCourseDiscussionList } from '@hooks/course/courseDiscussion/useCourseDiscussionList';

type HandleFetchCourseDiscussionListProps = {
  page: number;
  title?: string;
};

type CourseDiscussionBoardContentProps = {
  searchQuery: string;
  handleFetchCourseDiscussionList: ({ page, title }: HandleFetchCourseDiscussionListProps) => void;
  setSearchQuery: (searchQuery: string) => void;
  isDisplayCourseDiscussion: boolean;
};

const CourseDiscussionBoardContent = ({
  searchQuery,
  handleFetchCourseDiscussionList,
  setSearchQuery,
  isDisplayCourseDiscussion,
}: CourseDiscussionBoardContentProps) => {
  const router = useRouter();
  const idName = router.query.idName as string;

  const {
    courseDiscussionListData,
    courseDiscussionListPage,
    isCourseDiscussionListDataLoading,
  } = useCourseDiscussionList({ idName });

  const handleChangePagination = useCallback(
    (_event: ChangeEvent<unknown>, nextPage: number) => {
      if (courseDiscussionListPage !== nextPage) {
        handleFetchCourseDiscussionList({ page: nextPage, title: searchQuery });
      }
    },
    [courseDiscussionListPage, handleFetchCourseDiscussionList, searchQuery],
  );

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: '16px' }}>
        <CourseDiscussionBox
          discussionData={courseDiscussionListData?.items || []}
          isLoading={isCourseDiscussionListDataLoading}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          isDisplayCourseDiscussion={isDisplayCourseDiscussion}
        />
      </Box>

      {courseDiscussionListData?.pageCount > 1 && (
        <Pagination
          sx={{ display: 'flex', justifyContent: 'center', marginTop: 3 }}
          page={courseDiscussionListPage}
          count={courseDiscussionListData.pageCount}
          onChange={handleChangePagination}
          size="large"
        />
      )}
    </>
  );
};

export default CourseDiscussionBoardContent;
